import { adminEndpoints } from './endpoints/admin';
import { boardsEndpoints } from './endpoints/boards';
import { eventExports } from './endpoints/events';
import { exportEndpoints } from './endpoints/export';
import { externalEndpoints } from './endpoints/external';
import { filesEndpoints } from './endpoints/files';
import { foldersEndpoints } from './endpoints/folders';
import { internalEndpoints } from './endpoints/internal';
import { jiraEndpoints } from './endpoints/jira';
import { llmEndpoints } from './endpoints/llm';
import { meEndpoints } from './endpoints/me';
import { notificationsEndpoints } from './endpoints/notifications';
import { operationsEndpoints } from './endpoints/operations';
import { podsEndpoints } from './endpoints/pods';
import { settingsEndpoints } from './endpoints/settings';
import { slackExports } from './endpoints/slack';
import { surveysExports } from './endpoints/surveys';
import { tasksEndpoints } from './endpoints/tasks';
import { templateEndpoints } from './endpoints/templates';
import { usersEndpoints } from './endpoints/users';
import { workspacesEndpoints } from './endpoints/workspaces';

export const v2 = {
    admin: adminEndpoints,
    boards: boardsEndpoints,
    events: eventExports,
    export: exportEndpoints,
    external: externalEndpoints,
    files: filesEndpoints,
    folders: foldersEndpoints,
    internal: internalEndpoints,
    jira: jiraEndpoints,
    llm: llmEndpoints,
    me: meEndpoints,
    operations: operationsEndpoints,
    pods: podsEndpoints,
    settings: settingsEndpoints,
    slack: slackExports,
    surveys: surveysExports,
    templates: templateEndpoints,
    tasks: tasksEndpoints,
    users: usersEndpoints,
    workspaces: workspacesEndpoints,
    notifications: notificationsEndpoints,
};
